export * from './lib/shared-ui-icon-lib';
export * from './lib/icon/icon.component.module';
export * from './lib/icon/config';
export * from './lib/icon/icon.directive';
export * from '../icons/src';
